<template>
  <div>
    <div class="content-footer text-center mt-10">
      <p>© {{this.appYear()}} {{this.appName()}}
        <!-- · <a v-b-modal.modal-privacy>Privacy</a> · <a v-b-modal.modal-terms>Terms & Conditions</a> · <a v-b-modal.modal-cookies>Cookies</a>-->
      </p>
    </div>
    <!-- <PrivacyModal />
    <TermsModal />
    <CookiesModal /> -->
  </div>
</template>

<script>
// import PrivacyModal from '@/components/auth/modals/PrivacyModal'
// import TermsModal from '@/components/auth/modals/TermsModal'
// import CookiesModal from '@/components/auth/modals/CookiesModal'

export default {
  name: 'AuthFooter',
  methods: {
    appName() {
      return process.env.VUE_APP_NAME
    },
    appYear() {
      return process.env.VUE_APP_YEAR ? process.env.VUE_APP_YEAR : '2018'
    },
  },
  components: {
    // PrivacyModal,
    // TermsModal,
    // CookiesModal,
  },
}
</script>
